import { Component, input } from '@angular/core';
import { SyncState } from '@era/locations-sdk';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'era-device-sync-status-indicator',
  templateUrl: './device-sync-status-indicator.component.html',
  imports: [FaIconComponent],
})
export class DeviceSyncStatusIndicatorComponent {
  syncState = SyncState;
  readonly status = input.required<SyncState>();
}
